import { useCallback, useSyncExternalStore } from 'react';
import { getSession, subscribe, type AuthSession } from './auth';

export function useSession(): AuthSession | null {
  const sub = useCallback((cb: () => void) => subscribe(cb), []);
  return useSyncExternalStore(sub, getSession, getSession);
}
